module.exports = __webpack_public_path__ + "img/fengcai1.f6ade569.jpg";